import {createAction} from '@reduxjs/toolkit'

import {DeliveryRecipientType} from '@web/core/constants'

/** 배송지를 입력하는 사람 */
export const changeRecipient = createAction<DeliveryRecipientType>('deliveryInfo/changeRecipient')
